const getters = {
    uid: state => state.user.uid, //用户id
    routerPath: state => state.user.routerPath, //路由重定向
    userInfo: state => state.user.userInfo, //用户所有信息

    // alarmData: state => state.carTable.alarmData, //报警 alarm_type  从字典数据中获取alarm_type 数据
    // breadcrumbList: state => state.permission.breadcrumbList, // 面包屑数据
    // visitedViews: state => state.tagsView.visitedViews,

    //菜单
    // permission_routers: state => {
    //     // 对应permission.js中的state.routers
    //     return state.permission.routers;
    // },
    //权限
    // permission_perms: state => {
    //     // 对应permission.js中的state.perms
    //     return state.permission.perms;
    // },
    // addRouters: state => state.permission.addRouters
};
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js